import Entity from "@/services/westore/entities/entity";

export class Order extends Entity {
  static uri = "/orders";

  static store(payloadRequest) {
    return super.create(Order.uri, payloadRequest);
  }
  static uploadOrders(payloadRequest) {
    return super.create(`${Order.uri}/import`, payloadRequest);
  }
  static getTemplate(params = {}) {
    return super.getAll(`${Order.uri}/template`, params);
  }
  static getOne(id, params = {}) {
    return super.get(Order.uri, id, params);
  }

  static getAll(params = {}) {
    return super.getAll(Order.uri, params);
  }
  static update(params = {}) {
    let uri = `${Order.uri}/update`;
    return super.put({ uri, payload: params });
  }
  static updateStatus(params = {}, id) {
    let uri = `${Order.uri}/${id}/status`;
    return super.put({ uri, payload: params });
  }
  static cancel(id, payload) {
    let uri = `${Order.uri}/${id}/cancel`;
    return super.put({ uri, payload });
  }

  static getOptions(params = {}) {
    return super.getAll(`${Order.uri}/options`, params);
  }
  static getCountries(params = {}) {
    return super.getAll(`/countries`, params);
  }
  static getCities(id) {
    return super.getAll(`/countries/${id}/cities`);
  }

  static search(params = {}) {
    return super.getAll(`${Order.uri}/search`, params);
  }

  static export(type = "xlsx", filter) {
    const endpoint = `${Order.uri}/export?type=${type}`;
    return super.get(endpoint, null, filter);
  }
  static getFile(id, path) {
    const endpoint = `${Order.uri}/${id}/${path}`;
    return super.get(endpoint, null);
  }
}
